import React from 'react';

const ProductSkeleton = () => {
  return (
    <div className="min-w-0">
      <div className="h-full bg-white rounded-3xl border border-gray-200 shadow-sm flex flex-col relative overflow-hidden">
        {/* Shimmer Effect */}
        <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent"></div>
        
        {/* IMAGE SKELETON */}
        <div className="relative aspect-[0.86] sm:aspect-[0.9] bg-gray-200 rounded-t-3xl">
          {/* Badge Skeleton */}
          <div className="absolute top-3 left-3 sm:top-5 sm:left-5 w-10 sm:w-12 h-5 sm:h-6 bg-gray-300 rounded-full"></div>
          
          {/* Heart Icon Skeleton */}
          <div className="absolute top-3 right-3 sm:top-5 sm:right-5 w-8 sm:w-9 h-8 sm:h-9 bg-gray-300 rounded-2xl"></div>
        </div>

        {/* CONTENT SKELETON */}
        <div className="px-3 sm:px-5 pt-4 sm:pt-5 pb-4 sm:pb-6 flex flex-col flex-1 text-center space-y-3">
          {/* Title Skeleton */}
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 rounded w-3/4 mx-auto"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2 mx-auto"></div>
          </div>

          {/* Stars Skeleton */}
          <div className="flex justify-center space-x-1">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="w-3 h-3 bg-gray-200 rounded-sm"></div>
            ))}
          </div>

          {/* Price and Button Skeleton */}
          <div className="mt-auto flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-3 pt-4">
            <div className="h-8 bg-gray-200 rounded w-16"></div>
            <div className="h-8 bg-gray-200 rounded-2xl w-20"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

const ProductGridSkeleton = ({ count = 12 }) => {
  return (
    <div className="w-full col-span-full grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-5 lg:gap-6">
      {[...Array(count)].map((_, index) => (
        <ProductSkeleton key={index} />
      ))}
    </div>
  );
};

export { ProductSkeleton, ProductGridSkeleton };
